export default {
    key: 'cookie-policy',
    label: 'Cookie Policy',
    component: {
        name: 'CookiePolicyTemplate',
        loader: () => import('./CookiePolicyTemplate')
    },
    modules: {
        locations: [
            {
                label: 'Modules',
                name: 'default'
            },
        ]
    }
};
